import { ACTIONS } from "../01-actions/settingRatePomo";

const initialState = {
  status: null,
  settings: null,
  settingRateError: null,
  pomoStatus: null,
  pomoLimitSettings: [],
  pomoSettings: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // PROGRESS
    case ACTIONS.POMO_GET_RATE_SETTING_PROGRESS:
    case ACTIONS.POMO_GET_RATE_LIMIT_SETTING_PROGRESS:
    case ACTIONS.POMO_UPDATE_EZP_SETTING_PROGRESS:
    case ACTIONS.POMO_UPDATE_SETTING_RATE_PROGRESS:
    case ACTIONS.POMO_UPDATE_RATE_LIMIT_SETTING_PROGRESS:
    case ACTIONS.POMO_REFUND_CCT_PROGRESS:
    case ACTIONS.POMO_RECEIVING_CCT_PROGRESS:
    case ACTIONS.POMO_AUTHENTICATION_PROGRESS:
    case ACTIONS.POMO_UPDATE_EXCEL_FINANCE_SETTING_PROGRESS:
      return {
        ...state,
        pomoStatus: action.type,
      };
    case ACTIONS.POMO_UPDATE_EXCEL_FINANCE_SETTING_SUCCESS:
    case ACTIONS.POMO_UPDATE_EZP_SETTING_SUCCESS:
    case ACTIONS.POMO_UPDATE_SETTING_RATE_SUCCESS:
    case ACTIONS.POMO_UPDATE_RATE_LIMIT_SETTING_SUCCESS:
    case ACTIONS.POMO_REFUND_CCT_SUCCESS:
    case ACTIONS.POMO_RECEIVING_CCT_SUCCESS:
    case ACTIONS.POMO_AUTHENTICATION_SUCCESS:
      return {
        ...state,
        pomoStatus: action.type,
      };
    // SUCCESS
    case ACTIONS.POMO_GET_RATE_SETTING_SUCCESS:
      return {
        ...state,
        pomoStatus: action.type,
        pomoSettings: action.data.settings,
      };
    case ACTIONS.POMO_GET_RATE_LIMIT_SETTING_SUCCESS:
      return {
        ...state,
        pomoStatus: action.type,
        pomoLimitSettings: action.data.limitSettings
          ? action.data.limitSettings
          : [],
      };

    // FAILED
    case ACTIONS.POMO_GET_RATE_SETTING_FAILED:
    case ACTIONS.POMO_GET_RATE_LIMIT_SETTING_FAILED:
    case ACTIONS.POMO_UPDATE_EXCEL_FINANCE_SETTING_FAILED:
    case ACTIONS.POMO_UPDATE_EZP_SETTING_FAILED:
    case ACTIONS.POMO_UPDATE_SETTING_RATE_FAILED:
    case ACTIONS.POMO_UPDATE_RATE_LIMIT_SETTING_FAILED:
    case ACTIONS.POMO_REFUND_CCT_FAILED:
    case ACTIONS.POMO_RECEIVING_CCT_FAILED:
    case ACTIONS.POMO_AUTHENTICATION_FAILED:
      return {
        ...state,
        pomoStatus: action.type,
        settingRateError: action.data.error,
      };
    default:
      return state;
  }
};
